@let isDesktop = breakpoints() === "desktop";

<!-- Media content template (video/image + figcaption) -->
<ng-template #mediaContent let-item="item" let-size="size">
  @if (item.video; as video) {
    <div
      [style.height.px]="isDesktop ? size.dh : size.mh"
      [style.width.px]="isDesktop ? size.dw : undefined"
      class="video-wrapper">
      <app-video
        [autoplay]="true"
        [cover]="true"
        [isLoop]="video.isLoop ?? true"
        [isMuted]="video.isMuted ?? true"
        [mp4Url]="video.mp4Url"
        [previewImage]="video.image" />
    </div>
  } @else if (item.image) {
    <app-image [image]="item.image" [size]="size" />
  }
  @if ((isTitleDisplayed() && item.title) || item.legend || item.describe) {
    <figcaption>
      @if (isTitleDisplayed() && item.title; as title) {
        <h2 [innerHTML]="title" class="title"></h2>
      }
      @if (item.legend; as legend) {
        <div [innerHTML]="legend"></div>
      }
      @if (item.describe; as describe) {
        <div class="description">{{ describe }}</div>
      }
    </figcaption>
  }
</ng-template>

<!-- Highlight template -->
<ng-template #highlight let-item="item">
  <div class="col-xs-12 col-lg-12">
    <a [routerLink]="item.url">
      @if (item.video || item.image) {
        <figure>
          <ng-container
            *ngTemplateOutlet="mediaContent; context: { item: item, size: { dw: 996, dh: 623, mh: 219 } }" />
        </figure>
      }
    </a>
  </div>
</ng-template>

<section class="gallery-layout gallery-layout-6">
  @if (dataLoaded() && itemsPerPage() && desktopHeight()) {
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-lg-8">
          @if (dataTransformed().title || dataTransformed().subtitle) {
            <h1 class="title color-black font-ivy_mode title--normal size-h1 left">
              @if (dataTransformed().subtitle) {
                <span class="title color-grey_light font-ivy_mode title--line size-span align-left subtitle">{{
                  dataTransformed().subtitle
                }}</span>
              }
              @if (dataTransformed().title) {
                {{ dataTransformed().title }}
              }
            </h1>
          }
          @if (dataTransformed().html; as html) {
            <div [innerHTML]="html" class="paragraph"></div>
          }
        </div>
      </div>
      <div [ngClass]="{ 'wrapper-projects-cls-min-height ': !itemsLoaded() }">
        @if (itemsLoaded()) {
          <div class="row projects">
            <nav class="col-lg-2 nav">
              <ul class="items">
                @for (category of dataTransformed().categories; track category) {
                  <li class="item">
                    @if (category.url && category.label) {
                      <a
                        [routerLinkActiveOptions]="{ exact: true }"
                        [routerLink]="[category.url]"
                        class="link"
                        routerLinkActive="link-activated">
                        {{ category.label }}
                      </a>
                    }
                  </li>
                }
                @if (categories() && categories().size > 2) {
                  @for (category of categories(); track category) {
                    <li class="item">
                      @if (category) {
                        <span
                          (click)="filterByCategory(category)"
                          [ngClass]="{ 'link-activated': category === categoryActivated() }"
                          class="link">
                          {{ category }}
                        </span>
                      }
                    </li>
                  }
                }
              </ul>
            </nav>
            <div class="col-xs-12 col-lg-10">
              <!-- Display Highlight 1 -->
              @if (nbPage() === 1 && dataTransformed().highlight && !!dataTransformed().highlight![0]) {
                <div class="row line">
                  <ng-container
                    *ngTemplateOutlet="highlight; context: { item: dataTransformed().highlight![0] }"></ng-container>
                </div>
              }
              @if (itemsWithoutHighlightReady()) {
                @for (split of itemsWithoutHighlight() | splitArrayBy; track split; let index = $index) {
                  <div class="row line">
                    @for (item of split; track item; let first = $first; let last = $last) {
                      <div [class.first]="first" [class.last]="last && !first" class="col-xs-12 col-lg-6">
                        <a [routerLink]="item.url">
                          <figure>
                            <ng-container
                              *ngTemplateOutlet="
                                mediaContent;
                                context: { item: item, size: { dw: 486, dh: desktopHeight(), mh: 219 } }
                              " />
                          </figure>
                        </a>
                      </div>
                    }
                  </div>
                  <!-- Display Highlight 2 & 3 -->
                  @if (
                    nbPage() === 1 &&
                    dataTransformed().highlight &&
                    ((index === 1 && this.dataTransformed().highlight![1]) ||
                      (index === 3 && this.dataTransformed().highlight![2]))
                  ) {
                    <div class="row line">
                      <ng-container
                        *ngTemplateOutlet="
                          highlight;
                          context: {
                            item: index === 1 ? dataTransformed().highlight![1] : dataTransformed().highlight![2],
                          }
                        "></ng-container>
                    </div>
                  }
                }
              }
            </div>
          </div>
        }
      </div>
      <!-- Paginator -->
      <div class="row">
        <div class="col-xs-12 col-lg-12">
          @if (showPaginator()) {
            <app-pagination
              (changePage)="onChangePage($event)"
              [isMobile]="breakpoints() === 'mobile'"
              [limit]="itemsPerPage()"
              [totalCount]="totalItems()"
              class="pagination" />
          }
        </div>
      </div>
    </div>
  }
</section>
